import Truncate from './Truncate';

export default Truncate;
